import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ThemeProvider } from 'styled-components';
import { Loader } from 'components';
import { AuthRoute, PrivateRoute } from 'routes';
import { getValidMenus } from 'utils';
import * as Pages from 'pages';
import {
	unAuthPages,
	privatePages,
	getThemes,
	GlobalStyle,
	getUIVersion,
} from 'utils/router-static-data';
import { useAuth } from 'hooks';

export default function Router() {
	const auth = useAuth();
	const uiVersion = getUIVersion();

	return (
		<>
			<GlobalStyle />
			<ThemeProvider theme={getThemes('')}>
				<Loader />
				<Routes>
					{/* Unauth routes start here */}
					{unAuthPages?.map((page) => (
						<Route
							key={page?.key}
							path={page?.path}
							element={<AuthRoute>{page?.element}</AuthRoute>}
						/>
					))}
					{/* Unauth routes ends here */}

					{/* authenticated pages starts */}
					{getValidMenus(privatePages, auth, uiVersion).map((page) => (
						<Route
							key={page?.path}
							path={page?.path}
							element={
								<PrivateRoute breadCrumbsList={page.breadCrumbs}>
									{page?.element}
								</PrivateRoute>
							}
						/>
					))}
					{/* authenticated pages ends */}
					<Route path="*" element={<Pages.NotFound />} />
				</Routes>
			</ThemeProvider>
		</>
	);
}
